"use strict";
/*
 * Created on Mon Aug 06 2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../../core/model/data-dictionary/StructPropBuilder");

var BigIntegerValidator_1 = require("../../../core/model/data-dictionary/validators/BigIntegerValidator");

var BigNumberRangeValidator_1 = require("../../../core/model/data-dictionary/validators/BigNumberRangeValidator");

var ConstraintTypeEnum_1 = require("./ConstraintTypeEnum");

var SimpleConstraint_1 = require("./SimpleConstraint");
/**
 * Basically, it says keep the price fixed before promotion like x days before scheduled start date of planned promotion.
 *
 * @author RV
 */


var PromoProtection =
/*#__PURE__*/
function (_SimpleConstraint_1$S) {
  _inherits(PromoProtection, _SimpleConstraint_1$S);

  /**
   * @inheritDoc
   */
  function PromoProtection(value) {
    var _this;

    _classCallCheck(this, PromoProtection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromoProtection).call(this, value));
    _this.value = value;
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(PromoProtection, [{
    key: "getType",
    value: function getType() {
      return ConstraintTypeEnum_1.ConstraintTypeEnum.PromoProtection;
    }
  }]);

  return PromoProtection;
}(SimpleConstraint_1.SimpleConstraint);

exports.PromoProtection = PromoProtection;
PromoProtection.MIN_VALUE = 0;
PromoProtection.MAX_VALUE = 100; // tslint:disable-next-line:member-ordering

PromoProtection.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(SimpleConstraint_1.SimpleConstraint.name);
  return {
    value: builder.bigNum('value', new BigNumberRangeValidator_1.BigNumberRangeValidator(PromoProtection.MIN_VALUE, PromoProtection.MAX_VALUE), new BigIntegerValidator_1.BigIntegerValidator())
  };
}();